export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[600px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          有任何问题、建议或资源需求，欢迎通过以下方式与我们取得联系
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-background-50 border border-background-300/60 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-lg"></i>
            发送邮件
          </a>
          <a
            href="#contact"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-background-50 border border-background-300/60 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-wechat-line text-lg"></i>
            微信公众号
          </a>
          <a
            href="#contact"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-background-50 border border-background-300/60 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-feedback-line text-lg"></i>
            资源反馈
          </a>
        </div>
      </div>
    </section>
  );
}